import { PolicyStatus } from "kw/api/zeus";
import { COLOR as BADGE_COLOR } from "baseui/badge";

export const APP_CONSTANTS = {
  EMPTY_DISPLAY: "-",
};

export const policyStatusBadgeColor = {
  [PolicyStatus.CANCELLED]: BADGE_COLOR.negative,
  [PolicyStatus.EXPIRED]: BADGE_COLOR.accent,
  [PolicyStatus.BOUND]: BADGE_COLOR.positive,
  [PolicyStatus.PENDING_CANCELLATION]: BADGE_COLOR.warning,
};
